export const formatearNumero = (s) => {
  try {
    // Reemplaza la coma por un punto para convertir correctamente a número
    let numero = parseFloat(s);

    if (isNaN(numero)) {
      throw new Error("Valor no numérico");
    }

    // Formatear con separador de miles y dos decimales
    return numero.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch (error) {
    // Si hay un error, devuelve "0.00" en el formato correcto
    return "0.00";
  }
}